const CONFIRMATION_QUEUE_CHANGED = 'dink-admin:confirmation-queue-changed';

/** Notify the app shell that a queue action completed and the nav count is stale. */
export function notifyConfirmationQueueChanged(): void {
  window.dispatchEvent(new Event(CONFIRMATION_QUEUE_CHANGED));
}

/** Subscribe the app shell to queue mutations. Returns the matching cleanup. */
export function onConfirmationQueueChanged(listener: () => void): () => void {
  window.addEventListener(CONFIRMATION_QUEUE_CHANGED, listener);
  return () => window.removeEventListener(CONFIRMATION_QUEUE_CHANGED, listener);
}
